import { render, staticRenderFns } from "./COIFormInfo.vue?vue&type=template&id=662e177c&scoped=true&"
import script from "./COIFormInfo.vue?vue&type=script&lang=ts&"
export * from "./COIFormInfo.vue?vue&type=script&lang=ts&"
import style0 from "./COIFormInfo.vue?vue&type=style&index=0&id=662e177c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662e177c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
